if (!customElements.get('bb-custom-select')) {
  customElements.define(
    'bb-custom-select',
    class BbCustomSelect extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.render();
      }

      render() {
        // Get options from attribute
        const optionsAttr = this.getAttribute("options");
        const selectedValue = this.getAttribute("selected");

        let options = [];
        try {
          options = JSON.parse(optionsAttr);
        } catch (e) {
          console.error("Invalid options JSON:", optionsAttr);
        }

        // Find selected label
        let selectedLabel = "";
        if (options.length) {
          const selected = options.find(opt => opt[0] === selectedValue);
          selectedLabel = selected ? selected[1] : options[0][1];
        }

        // Shadow DOM content
        this.innerHTML = `
          <style>
            .select-wrapper.open .options {
              display: block;
              width: fit-content;
              position: absolute;
              left: 90px;
            }
          </style>
          <div class="select-wrapper select">
            <div class="selected custom-select active">${selectedLabel}</div>
            <ul class="options select-options" id="select-options">
              ${options.map(opt => `<li data-value="${opt[0]}">${opt[1]}</li>`).join("")}
            </ul>
          </div>
        `;

        this.addEvents();
      }

      addEvents() {
        const wrapper = this.querySelector(".select-wrapper");
        const selectedDiv = this.querySelector(".selected");
        const optionsList = this.querySelectorAll(".options li");
        const name = this.getAttribute("name");
        const id = this.getAttribute("id");

        selectedDiv.addEventListener("click", () => {
          wrapper.classList.toggle("open");
        });

        optionsList.forEach(li => {
          li.addEventListener("click", () => {
            const value = li.getAttribute("data-value");
            const label = li.textContent;

            // Update selected display
            selectedDiv.textContent = label;

            // Close dropdown
            wrapper.classList.remove("open");

            this.value = value;
            this.text = label;

            // Dispatch custom change event
            this.dispatchEvent(new CustomEvent("change", {
              detail: { id, name, value, label },
              bubbles: true
            }));
          });
        });

        // Close dropdown when clicking outside
        document.addEventListener("click", (e) => {
          if (!this.contains(e.target)) {
            wrapper.classList.remove("open");
          }
        });
      }
    }
  );
}
